export default "__VITE_ASSET__CTqE0AQh__"